// components/LoadingOverlay.js - Loading overlay component
import React from 'react';
import { cn } from '../lib/utils';

function LoadingOverlay({ isLoading, message = 'Loading...', className }) {
  if (!isLoading) return null;

  return (
    <div className={cn("fixed inset-0 bg-white/80 flex flex-col items-center justify-center z-50", className)}>
      <div className="w-[50px] h-[50px] border-4 border-primary/20 rounded-full border-t-primary animate-spin"></div>
      <p className="mt-4 text-base text-primary font-medium">{message}</p>
    </div>
  );
}

export default LoadingOverlay;
